export default __webpack_public_path__ + "static/media/arrow-down-gray.47b67074.svg";